import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import {
  CONDITIONS_GENERALES,
  MAINTENANCE,
  MENTIONS_LEGALES,
  REGULARISATION_OFF,
} from "@shared/constants/route.constants";
import { VYV_GESTION_DONNEES } from "@shared/constants/url.constants";

@Component({
  selector: "app-footer",
  standalone: true,
  templateUrl: "./footer.component.html",
  imports: [CommonModule, RouterLink, TranslateModule],
})
export class FooterComponent {
  MENTIONS_LEGALES = MENTIONS_LEGALES;
  CONDITIONS_GENERALES = CONDITIONS_GENERALES;
  VYV_GESTION_DONNEES = VYV_GESTION_DONNEES;

  constructor(public router: Router) {}

  showFooter() {
    const excludedUrls = [MAINTENANCE, REGULARISATION_OFF];
    const url = this.router.url.replace("/", "");
    return !excludedUrls.includes(url);
  }
}
